import ExcelJS from "exceljs"
import { assignedApps, installedApps } from "../../terminals/components/terminalApplicationData"

export const terminalViews = { approved: "Registered — approved", approval: "Pending approval", unassigned: "Unassigned terminals", bulk: "Pending bulk registration" }
export function terminalReportHeaders({ view, filter, orgCode, groupId, serial, status, applicationId }) {
  const selectedFilter = view === "unassigned" ? "F_ORG_CODE" : filter
  const value = selectedFilter === "F_ORG_CODE" ? orgCode : selectedFilter === "F_GRP_ID" ? groupId : serial?.trim()
  if (!value || (selectedFilter === "F_GRP_ID" && !orgCode)) throw new Error("Select or enter a value for the selected filter.")
  if (view === "approved" && status && !applicationId?.trim()) throw new Error("App ID is required when an application status is selected.")
  return {
    Action: { approved: "V_ALL_APPR_TMNL", approval: "V_ALL_NON_APPR_TMNL", unassigned: "V_ALL_UNASSIGNED_TMNL", bulk: "V_ALL_PENDING_TMNL" }[view],
    Filter: selectedFilter, Value: value, "Sort-Column": "tmnl_id", "Sort-Order": "asc", "Is-Pagination": "false",
    ...(view === "approved" ? { "X-Additional-Info": true } : {}),
    ...(view === "approved" && status ? { "Latest-App-Status": status, "Application-Id": applicationId.trim() } : {}),
  }
}
const field = (key, header, numeric = false) => ({ key, header, numeric, value: row => key.split(".").reduce((value, part) => value?.[part], row) })
export const terminalFields = [
  field("serialNo", "Terminal serial"), field("terminalId", "Terminal ID"), field("model", "Model"), field("status", "Status"),
  field("orgName", "Organization"), field("orgCode", "Organization code"), field("orgId", "Organization ID"),
  field("groupName", "Group"), field("groupId", "Group ID"),
  { key: "assignedCount", header: "Assigned apps", numeric: true, value: row => assignedApps(row).length },
  { key: "installedCount", header: "Installed apps", value: row => installedApps(row) == null ? "Not reported" : installedApps(row).length, numeric: true },
  field("createdDateTime", "Created"), field("updatedDateTime", "Last updated"),
  field("sseConnectionDtl.connStatus", "Connection status"), field("sseConnectionDtl.instanceName", "Connection instance"),
  field("sseConnectionDtl.ipAddress", "IP address"), field("sseConnectionDtl.connCreatedDateTime", "Connection created"),
  field("sseConnectionDtl.connUpdatedDateTime", "Connection updated"),
]
export const terminalAppFields = [
  field("terminalId", "Terminal ID"), field("serialNo", "Terminal serial"), field("orgCode", "Organization code"), field("groupId", "Group ID"), field("groupName", "Group"),
  field("applicationId", "Application ID"), field("appName", "Application name"), field("appId", "Package ID"), field("appVersion", "Version"),
  field("versionCode", "Version code", true), field("downldStatus", "Download status"), field("assignedAt", "Assigned at"), field("lastModifiedAt", "Last modified"),
]
export const terminalAppRows = (rows, installed = false) => rows.flatMap(row => ((installed ? installedApps(row) : assignedApps(row)) || []).map(app => ({
  ...app, terminalId: row.terminalId, serialNo: row.serialNo, orgCode: row.orgCode, groupId: row.groupId, groupName: row.groupName,
})))
export const terminalReportSheets = rows => [
  ["Terminals", terminalFields, rows], ["Assigned applications", terminalAppFields, terminalAppRows(rows)],
  ["Installed applications", terminalAppFields, terminalAppRows(rows, true)],
]
export function buildTerminalReportWorkbook(rows) {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = "AIKEN TOMS"
  workbook.created = new Date()
  terminalReportSheets(rows).forEach(([name, fields, items]) => {
    const sheet = workbook.addWorksheet(name, { views: [{ state: "frozen", ySplit: 1 }] })
    sheet.columns = fields.map(field => ({ header: field.header, key: field.key, width: /name|Package/.test(field.header) ? 48 : 25 }))
    items.forEach(item => sheet.addRow(fields.map(field => {
      const value = field.value(item)
      return value == null ? null : field.numeric ? value : String(value)
    })))
    sheet.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: fields.length } }
    sheet.eachRow((row, index) => {
      row.alignment = { vertical: "top", wrapText: true }
      if (index === 1) {
        row.height = 32
        row.font = { bold: true, color: { argb: "FFFFFFFF" } }
        row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF126D71" } }
      } else if (index % 2 === 0) row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF1F6F6" } }
    })
  })
  return workbook
}
